import React from 'react';

import {
  TableBody,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
} from '@gogame/components';

import { SpendAdjustmentRow } from './';

const SpendAdjustments = ({ data = [], onOpenSpendAdjustment }) => (
  <TableContainer>
    <Table>
      <TableHead>
        <TableRow>
          <TableCell width={70}>ID</TableCell>
          <TableCell>Name</TableCell>
          <TableCell width={130}>Status</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {data.map((adjustment) => (
          <SpendAdjustmentRow
            key={adjustment.id}
            adjustment={adjustment}
            onOpenSpendAdjustment={onOpenSpendAdjustment}
          />
        ))}
      </TableBody>
    </Table>
  </TableContainer>
);

export default SpendAdjustments;
